import axios from './axios';
import { appConfig } from '../../config';
import { DataStorageData } from '../../shared/types';

export const tanAndTokenCreation = (
  transactionId: string,
  sms: boolean,
  legalEntity: string | null
): Promise<{ data: { tan?: string; token?: string; newTransaction?: boolean; message?: string } }> => {
  return axios.get(`/api/${appConfig.brandName}/auth/${transactionId}/create/${sms}/${legalEntity}`);
};

export const checkTanValidity = async (
  transactionId: string,
  tan: string
): Promise<{ data: { status: 'OK' | 'ERROR'; token?: string; message?: string; data?: DataStorageData } }> => {
  try {
    return await axios.post(`/api/${appConfig.brandName}/auth/${transactionId}/checkTan`, { tan });
  } catch (e: any) {
    if (e?.response?.status === 400) {
      return e.response;
    }
    throw e;
  }
};

export const checkTokenValidity = (
  transactionId: string,
  token: string
): Promise<{ status: 'OK' | 'ERROR' }> => {
  return axios.post(`/api/${appConfig.brandName}/auth/${transactionId}/checkToken`, { token });
};
